import { configureStore } from '@reduxjs/toolkit';
import incentive from './reducer/Incentive';
import IncentiveDetail from './reducer/incentiveDetail';
import BannerInfo from './reducer/BannerInfo';
import UserInformation from './reducer/UserInformation';
import SubscriptionUser from './reducer/SubscriptionUser';
import AditionalInfo from './reducer/AditionalInfo';

export default configureStore({
  reducer: {
    incentiveNext: incentive,
    IncentiveDetails: IncentiveDetail,
    bannerDetails: BannerInfo,
    UserDetails: UserInformation,
    SubscriptionUserDetails: SubscriptionUser,
    aditionalUserInfo: AditionalInfo,
  },
});
